module.exports = __webpack_public_path__ + "static/media/event-bg.6d922c6a.png";